import { calculateDistance, formatTimeAgo, escapeHtml } from '../../utils/helpers';
import CONFIG from '../../config/app-config';

export default class NearbyView {
  constructor() {
    this.nearbyMap = null;
    this.storyMarkers = [];
    this.userMarker = null;
    this.layerControl = null;
  }

  async render() {
    return `
      <div id="page-nearby" class="page-content active">
          <section aria-labelledby="nearby-map-title">
              <h2 id="nearby-map-title" class="sr-only">Peta Lokasi Terdekat</h2>
              <div class="map-container" id="nearby-map" role="application" aria-label="Peta interaktif lokasi terdekat"></div>
          </section>
          <section class="post-wrapper" aria-labelledby="nearby-posts-title">
              <h2 id="nearby-posts-title" class="sr-only">Postingan Terdekat</h2>
              <div class="post-list" id="nearby-posts-container">
                  <div class="loading-post">
                      <div class="hg-animate" aria-hidden="true"></div>
                      <p>Memuat postingan terdekat...</p>
                  </div>
              </div>
          </section>
      </div>
    `;
  }

  async afterRender() {
    // Setup handled by presenter
  }

  showLoading(container) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (container) {
      container.innerHTML = `
        <div class="loading-post">
          <div class="hg-animate" aria-hidden="true"></div>
          <p>Memuat...</p>
        </div>
      `;
    }
  }

  showEmptyState(container, message) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (container) {
      container.innerHTML = `
        <div class="empty-state">
          <span class="material-symbols-rounded" aria-hidden="true">inbox</span>
          <h3>Tidak ada konten</h3>
          <p>${message}</p>
        </div>
      `;
    }
  }

  showAuthRequired(container) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (container) {
      container.innerHTML = `
        <div class="auth-required">
          <span class="material-symbols-rounded" aria-hidden="true">login</span>
          <h3>Masuk diperlukan</h3>
          <p>Silakan masuk atau daftar untuk melihat konten ini</p>
          <button class="login-btn" onclick="app.navigateTo('auth')" aria-label="Masuk sekarang">
            <span class="material-symbols-rounded" aria-hidden="true">login</span>
            Masuk Sekarang
          </button>
        </div>
      `;
    }
  }

  showGuestMapPlaceholder(container) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (container) {
      container.innerHTML = `
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 300px; background: var(--bg-container); border-radius: var(--radius-m);">
          <span class="material-symbols-rounded" style="font-size: 3rem; color: var(--primary); margin-bottom: 1rem;">login</span>
          <p style="color: var(--text-secondary); text-align: center;">Masuk untuk melihat peta lokasi terdekat</p>
        </div>
      `;
    }
  }

  initializeMap(config) {
    try {
      this.nearbyMap = new maplibregl.Map(config);
      this.nearbyMap.addControl(new maplibregl.NavigationControl(), 'top-right');
      return this.nearbyMap;
    } catch (error) {
      throw new Error('Gagal memuat peta: ' + error.message);
    }
  }

  addMapLayerControl(onLayerChange) {
    if (!this.nearbyMap) return;

    const view = this;
    
    class LayerControl {
      onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group';
        
        const button = document.createElement('button');
        button.className = 'maplibregl-ctrl-icon';
        button.type = 'button';
        button.innerHTML = '<span class="material-symbols-rounded">layers</span>';
        button.title = 'Ubah layer peta';
        
        const dropdown = document.createElement('div');
        dropdown.className = 'layer-dropdown';
        dropdown.style.cssText = 'position: absolute; top: 100%; left: 0; background: var(--bg-container); border: 1px solid var(--border-color); border-radius: 4px; display: none; min-width: 120px; box-shadow: 0 2px 4px rgba(0,0,0,0.2);';
        
        const layers = [
          { name: 'Streets', value: 'streets' },
          { name: 'Satellite', value: 'satellite' },
          { name: 'Terrain', value: 'terrain' }
        ];
        
        layers.forEach(layer => {
          const item = document.createElement('div');
          item.textContent = layer.name;
          item.className = 'layer-list';
          item.style.cssText = 'padding: 8px 12px; cursor: pointer; color: var(--text-primary);';
          item.addEventListener('click', () => {
            onLayerChange(layer.value);
            dropdown.style.display = 'none';
          });
          dropdown.appendChild(item);
        });
        
        button.addEventListener('click', (e) => {
          e.stopPropagation();
          dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
        });
        
        document.addEventListener('click', () => {
          dropdown.style.display = 'none';
        });
        
        this._container.appendChild(button);
        this._container.appendChild(dropdown);
        return this._container;
      }
      
      onRemove() {
        if (this._container && this._container.parentNode) {
          this._container.parentNode.removeChild(this._container);
        }
        this._map = undefined;
      }
    }
    
    this.layerControl = new LayerControl();
    this.nearbyMap.addControl(this.layerControl, 'top-left');
  }

  setMapStyle(styleUrl) {
    if (this.nearbyMap) {
      this.nearbyMap.setStyle(styleUrl);
    }
  }

  setMapCenter(lon, lat, zoom = 10) {
    if (this.nearbyMap) {
      this.nearbyMap.setCenter([lon, lat]);
      this.nearbyMap.setZoom(zoom);
    }
  }

  addUserLocationMarker(location) {
    if (!this.nearbyMap || !location) return;

    if (this.userMarker) {
      this.userMarker.remove();
    }

    this.userMarker = new maplibregl.Marker({ color: '#28a745' })
      .setLngLat([location.lon, location.lat])
      .setPopup(new maplibregl.Popup().setHTML('<p>Lokasi Anda</p>'))
      .addTo(this.nearbyMap);
  }

  addRangeCircle(circleData) {
    if (!this.nearbyMap || !circleData) return;

    if (!this.nearbyMap.loaded()) {
      this.nearbyMap.on('load', () => this.addRangeCircle(circleData));
      return;
    }

    if (this.nearbyMap.getSource('range-circle')) {
      this.nearbyMap.removeLayer('range-circle-fill');
      this.nearbyMap.removeLayer('range-circle-stroke');
      this.nearbyMap.removeSource('range-circle');
    }

    this.nearbyMap.addSource('range-circle', {
      type: 'geojson',
      data: circleData
    });

    this.nearbyMap.addLayer({
      id: 'range-circle-fill',
      type: 'fill',
      source: 'range-circle',
      paint: {
        'fill-color': '#B84C28',
        'fill-opacity': 0.1
      }
    });

    this.nearbyMap.addLayer({
      id: 'range-circle-stroke',
      type: 'line',
      source: 'range-circle',
      paint: {
        'line-color': '#B84C28',
        'line-width': 2,
        'line-opacity': 0.6
      }
    });
  }

  clearStoryMarkers() {
    if (this.storyMarkers) {
      this.storyMarkers.forEach(marker => marker.remove());
    }
    this.storyMarkers = [];
  }

  addStoryMarkers(stories) {
    this.clearStoryMarkers();

    if (!this.nearbyMap || !stories.length) return;

    stories.forEach(story => {
      if (story.lat && story.lon) {
        const popup = new maplibregl.Popup({ offset: 25 })
          .setHTML(`
            <div style="padding: 0.5rem;">
              <h4 style="margin: 0 0 0.5rem 0;">${this.escapeHtml(story.name)}</h4>
              <p style="margin: 0; font-size: 0.875rem;">${this.escapeHtml(story.description.substring(0, 50))}${story.description.length > 50 ? '...' : ''}</p>
              <button onclick="app.navigateToPost('${story.id}')" style="margin-top: 0.5rem; padding: 0.25rem 0.5rem; background: var(--primary); color: white; border: none; border-radius: 0.25rem; cursor: pointer; font-size: 0.75rem;">Lihat Detail</button>
            </div>
          `);

        const marker = new maplibregl.Marker({ color: '#B84C28' })
          .setLngLat([story.lon, story.lat])
          .setPopup(popup)
          .addTo(this.nearbyMap);
        
        this.storyMarkers.push(marker);
      }
    });
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  renderStories(stories, container, currentUserLocation) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (!container) return;

    container.innerHTML = '';
    
    let storiesHtml = '';
    stories.forEach(story => {
      const timeAgo = formatTimeAgo(story.createdAt);
      const isBookmarked = story.isBookmarked || false;
      
      let distanceInfo = '';
      if (story.lat && story.lon && currentUserLocation) {
        const distance = calculateDistance(
          currentUserLocation.lat,
          currentUserLocation.lon,
          story.lat,
          story.lon
        );
        distanceInfo = `<span class="distance-info">${distance.toFixed(1)} km dari Anda</span>`;
      }
      
      storiesHtml += `
        <article class="postingan" data-story-id="${story.id}">
          <div class="post-user">
            <div class="user-sender">
              <div class="poster-photo">
                <img src="${CONFIG.AVATAR_BASE_URL}?seed=${encodeURIComponent(story.name)}" alt="Foto profil ${story.name}" width="48" height="48" loading="lazy">
              </div>
              <div class="sender-post">
                <h3>${story.name}</h3>
                ${story.lat && story.lon ? `
                  <button type="button" class="location-sender" aria-label="Lihat lokasi" data-text_tip="Lihat lokasi" data-hover_tip="right" data-dev_tip="desktop">
                    <span class="material-symbols-rounded" aria-hidden="true">location_on</span>
                    <p class="location-text-${story.id}">Memuat lokasi...</p>
                  </button>
                ` : ''}
              </div>
            </div>
            <div class="time-post">
              <p data-timestamp="${story.createdAt}">${timeAgo}</p>
            </div>
          </div>
          <div class="isi-postingan">
            <div class="post-text">${escapeHtml(story.description)}</div>
            ${story.photoUrl ? `
              <div class="post-image">
                <img src="${story.photoUrl}" alt="Story image" loading="lazy">
              </div>
            ` : ''}
          </div>
          ${story.lat && story.lon ? `
            <div class="location-view">
              <button type="button" class="box-mini-maps" aria-label="Lihat lokasi di peta" data-text_tip="Lihat lokasi di peta" data-hover_tip="top" data-dev_tip="desktop" onclick="app.navigateToPost('${story.id}')">
                <div class="info-maps">
                  <div class="mini-map">
                    <span class="material-symbols-rounded" aria-hidden="true">share_location</span>
                  </div>
                  <div class="nama-daerah">
                    <h4 class="map-location-name-${story.id}">Memuat lokasi...</h4>
                    <p>lat: ${story.lat.toFixed(6)} · lon: ${story.lon.toFixed(6)}</p>
                  </div>
                </div>
                <div class="info-jarak">
                  <span class="view-location">${distanceInfo || 'Lihat lokasi'}</span>
                </div>
              </button>
            </div>
          ` : ''}
          <div class="action-post">
            <button class="bookmark-this ${isBookmarked ? 'bookmarked' : ''}" data-story-id="${story.id}" data-text_tip="${isBookmarked ? 'Hapus dari bookmark' : 'Tambah ke bookmark'}" data-hover_tip="top" data-dev_tip="desktop">
              <span class="material-symbols-rounded" aria-hidden="true">bookmark</span>
              <span>${isBookmarked ? 'Tersimpan' : 'Simpan'}</span>
            </button>
            <button class="share-this" data-story-id="${story.id}" data-text_tip="Bagikan cerita" data-hover_tip="top" data-dev_tip="desktop">
              <span class="material-symbols-rounded" aria-hidden="true">share</span>
              <span>Bagikan</span>
            </button>
          </div>
        </article>
      `;
    });
    
    container.innerHTML = storiesHtml;
  }

  updateLocationName(storyId, locationName) {
    const locationElements = document.querySelectorAll(`.location-text-${storyId}`);
    locationElements.forEach(el => {
      el.textContent = locationName;
    });
    
    const mapLocationElements = document.querySelectorAll(`.map-location-name-${storyId}`);
    mapLocationElements.forEach(el => {
      el.textContent = locationName;
    });
  }

  updateBookmarkStatus(storyId, isBookmarked) {
    const buttons = document.querySelectorAll(`.bookmark-this[data-story-id="${storyId}"]`);
    buttons.forEach(btn => {
      if (isBookmarked) {
        btn.classList.add('bookmarked');
        btn.querySelector('span:last-child').textContent = 'Tersimpan';
        btn.setAttribute('data-text_tip', 'Hapus dari bookmark');
      } else {
        btn.classList.remove('bookmarked');
        btn.querySelector('span:last-child').textContent = 'Simpan';
        btn.setAttribute('data-text_tip', 'Tambah ke bookmark');
      }
    });
  }

  setupPostInteractionEventListeners(onBookmark, onShare, onImageClick) {
    this.globalClickHandler = (e) => {
      const bookmarkBtn = e.target.closest('.bookmark-this');
      if (bookmarkBtn) {
        e.stopPropagation();
        const storyId = bookmarkBtn.dataset.storyId;
        onBookmark(storyId);
        return;
      }

      const shareBtn = e.target.closest('.share-this');
      if (shareBtn) {
        e.stopPropagation();
        const storyId = shareBtn.dataset.storyId;
        onShare(storyId);
        return;
      }

      const postImage = e.target.closest('.post-image img');
      if (postImage) {
        e.stopPropagation();
        onImageClick(postImage.src);
        return;
      }
    };
    
    document.addEventListener('click', this.globalClickHandler);
  }

  clearSidebarUsers() {
    const container = document.querySelector('#nearby-users');
    if (container) container.innerHTML = '';
  }

  showSidebarLoading() {
    const container = document.querySelector('#nearby-users');
    if (!container) return;
    
    container.innerHTML = `
      <div class="loading-post">
        <div class="hg-animate" aria-hidden="true"></div>
        <p>Memuat pengguna terdekat...</p>
      </div>
    `;
  }

  renderSidebarUsers(users, currentUserLocation) {
    const container = document.querySelector('#nearby-users');
    if (!container) return;
    
    if (users.length === 0) {
      this.showSidebarError(500); // default distance
      return;
    }
  
    let usersHtml = '';
    users.forEach(story => {
      const timeAgo = this.formatTimeAgo(story.createdAt);
      const distance = currentUserLocation ? 
        this.calculateDistance(
          currentUserLocation.lat,
          currentUserLocation.lon,
          story.lat,
          story.lon
        ) : null;
      
      usersHtml += `
        <a href="#/post/${story.id}" class="post-near">
          <div class="sender-priview">
            <div class="preview-user">
              <img src="${CONFIG.AVATAR_BASE_URL}?seed=${encodeURIComponent(story.name)}" alt="${story.name}" width="40" height="40" loading="lazy">
            </div>
            <div class="preview-name">
              <h3>${story.name}</h3>
              <p class="location-text">
                ${distance ? `${distance.toFixed(1)} km dari Anda` : 'Memuat lokasi...'}
              </p>
            </div>
          </div>
          <div class="latest-text">
            <p>${timeAgo}</p>
          </div>
        </a>
      `;
    });
  
    container.innerHTML = usersHtml;
  }

  formatTimeAgo(dateString) {
    // ane copy dari utils/helpers.js biar pure mvp dan bodohin view
    const now = new Date();
    const date = new Date(dateString);
    const seconds = Math.floor((now - date) / 1000);
  
    if (seconds < 60) return 'Baru saja';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} menit lalu`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} jam lalu`;
    const days = Math.floor(hours / 24);
    return `${days} hari lalu`;
  }
  
  calculateDistance(lat1, lon1, lat2, lon2) {
    // ane copy dari nearby-model.js biar pure mvp dan bodohin view
    const R = 6371;
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  }
  
  deg2rad(deg) {
    return deg * (Math.PI/180);
  }
  
  showSidebarError(distance) {
    const container = document.querySelector('#nearby-users');
    if (!container) return;
    
    container.innerHTML = `
      <div class="empty-state">
        <span class="material-symbols-rounded" aria-hidden="true">inbox</span>
        <h3>Tidak ada konten</h3>
        <p>Belum ada postingan dalam radius ${distance} km</p>
      </div>
    `;
  }

  updateRangeCircle(circleData) {
    if (!this.nearbyMap || !circleData) return;
    
    // Update circle tanpa reload map
    if (this.nearbyMap.getSource('range-circle')) {
      this.nearbyMap.getSource('range-circle').setData(circleData);
    } else {
      this.addRangeCircle(circleData);
    }
  }

  isDarkMode() {
    return document.body.classList.contains('dark');
  }

  showMapError(container, message = 'Gagal memuat peta') {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (container) {
      container.innerHTML = `<p style="padding: 2rem; text-align: center; color: var(--text-secondary);">${message}</p>`;
    }
  }

  cleanup() {
    if (this.globalClickHandler) {
      document.removeEventListener('click', this.globalClickHandler);
      this.globalClickHandler = null;
    }

    this.clearStoryMarkers();
    
    if (this.userMarker) {
      this.userMarker.remove();
      this.userMarker = null;
    }
    
    if (this.nearbyMap) {
      this.nearbyMap.remove();
      this.nearbyMap = null;
    }
  }
}